/**
 * Query-key conventions used by @homesite/hooks.
 * Keep these in one place so cache invalidation is sane.
 */
export const queryKeys = {
	all: ["api"] as const,

	loanCases: {
		all: ["api", "loan-cases"] as const,
		list: (query?: Record<string, unknown>) =>
			["api", "loan-cases", "list", query ?? {}] as const,
		detail: (id: string) => ["api", "loan-cases", id] as const,
		audit: (id: string) => ["api", "loan-cases", id, "audit"] as const,
		payments: (id: string) => ["api", "loan-cases", id, "payments"] as const,
	},

	publicVerification: {
		all: ["api", "public-verification"] as const,
		events: {
			all: ["api", "public-verification", "events"] as const,
			byHash: (hash: string) =>
				["api", "public-verification", "events", hash] as const,
			list: (page: number, limit: number) =>
				[
					"api",
					"public-verification",
					"events",
					"list",
					{ page, limit },
				] as const,
		},
		loans: {
			all: ["api", "public-verification", "loans"] as const,
			timeline: (
				loanId: string,
				page: number,
				limit: number,
				filters?: { eventType?: string; respaCode?: string },
			) =>
				[
					"api",
					"public-verification",
					"loans",
					loanId,
					"timeline",
					{ page, limit, ...filters },
				] as const,
			respa: (loanId: string) =>
				["api", "public-verification", "loans", loanId, "respa"] as const,
			auditSummary: (loanId: string) =>
				[
					"api",
					"public-verification",
					"loans",
					loanId,
					"audit-summary",
				] as const,
		},
		batches: {
			all: ["api", "public-verification", "batches"] as const,
			list: (
				page: number,
				limit: number,
				filters?: { chainId?: number; anchored?: boolean },
			) =>
				[
					"api",
					"public-verification",
					"batches",
					"list",
					{ page, limit, ...filters },
				] as const,
			detail: (root: string) =>
				["api", "public-verification", "batches", root] as const,
			events: (root: string, page: number, limit: number) =>
				[
					"api",
					"public-verification",
					"batches",
					root,
					"events",
					{ page, limit },
				] as const,
		},
		chains: ["api", "public-verification", "chains"] as const,
		systemHealth: ["api", "public-verification", "system", "health"] as const,
		integrityAlerts: {
			all: ["api", "public-verification", "integrity-alerts"] as const,
			list: (params?: {
				since?: string;
				severity?: string;
				limit?: number;
				offset?: number;
			}) =>
				[
					"api",
					"public-verification",
					"integrity-alerts",
					"list",
					params ?? {},
				] as const,
		},
	},
} as const;
